import { AccountPageHeader } from '../../account/components/AccountPageHeader';
import { ReviewItem } from '../components/ReviewItem';
import { usePendingReviewsQuery } from '../reviews.services';
import { Skeleton, EmptyState } from '@shopmuchmore/design-system';
import { CheckCircle2 } from 'lucide-react';

export function PendingReviewsPage() {
    const { data: pendingReviews, isLoading } = usePendingReviewsQuery();

    return (
        <div className="w-full space-y-8 max-w-4xl">
            <AccountPageHeader
                title="Pending Reviews"
                description="Share your experience with your recent purchases."
            />

            <div className="space-y-4">
                {isLoading ? (
                    // Loading Skeletons
                    Array.from({ length: 3 }).map((_, i) => (
                        <div key={i} className="bg-white border-[1.5px] border-gray-100 rounded-[24px] p-6 flex gap-6 items-center">
                            <Skeleton className="w-20 h-20 rounded-xl" />
                            <div className="flex-1 space-y-2">
                                <Skeleton className="h-6 w-1/2" />
                                <Skeleton className="h-4 w-1/4" />
                            </div>
                            <Skeleton className="h-10 w-32 rounded-full" />
                        </div>
                    ))
                ) : (
                    pendingReviews?.map((product) => (
                        <ReviewItem
                            key={`${product.order_number}-${product.product_slug}`}
                            product={product}
                        />
                    ))
                )}

                {!isLoading && (!pendingReviews || pendingReviews.length === 0) && (
                    <EmptyState
                        icon={CheckCircle2}
                        title="You're all caught up!"
                        description="No pending reviews. Thank you for sharing your experience with your recent purchases!"
                        iconClassName="bg-primary/5"
                        className="py-12"
                    />
                )}
            </div>
        </div>
    );
}



